import SharedLayout from "./shared-layout/SharedLayout";

export default function DashboardLayoutSwitcher() {
  return <SharedLayout />;
}